var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 116,
    viewBox: "0 0 131 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 65.5C126 32.0859 98.9142 5 65.5 5C32.0859 5 5 32.0859 5 65.5C5 98.9142 32.0859 126 65.5 126",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.383 29.3595C106.021 29.7438 99.1549 31.8258 94.3943 37.986C85.7907 49.1133 77.1929 50.0482 71.4572 46.3372C62.8536 40.7735 70.0863 31.7513 59.9915 26.853C53.4126 23.6582 52.4949 14.9686 56.16 8.14307M8.14062 59.7645C12.517 63.5615 18.637 67.0374 25.8582 67.0374C40.7711 67.0374 43.7537 69.888 43.7537 81.2849C43.7537 92.6818 43.7537 92.6818 46.7362 101.228C48.6749 106.792 49.3517 112.344 45.4859 117.122M110.804 110.979L122.855 122.857M117.739 94.4426C117.736 97.4932 117.132 100.513 115.962 103.33C114.791 106.148 113.078 108.707 110.919 110.862C108.759 113.017 106.197 114.725 103.377 115.89C100.558 117.054 97.5366 117.652 94.4861 117.649C91.4355 117.652 88.4142 117.054 85.5947 115.89C82.7752 114.725 80.2127 113.017 78.0535 110.862C75.8943 108.707 74.1807 106.148 73.0105 103.33C71.8403 100.513 71.2365 97.4932 71.2335 94.4426C71.2365 91.3921 71.8403 88.372 73.0105 85.5548C74.1807 82.7376 75.8943 80.1784 78.0535 78.0235C80.2127 75.8686 82.7752 74.16 85.5947 72.9954C88.4142 71.8308 91.4355 71.2329 94.4861 71.2359C97.5366 71.2329 100.558 71.8308 103.377 72.9954C106.197 74.16 108.759 75.8686 110.919 78.0235C113.078 80.1784 114.791 82.7376 115.962 85.5548C117.132 88.372 117.736 91.3921 117.739 94.4426Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon2);
export default __webpack_public_path__ + "static/media/about-icon2.fcf5454db20eebe30f77c3e42aee817c.svg";
export { ForwardRef as ReactComponent };